import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').factory('Activity', activityService);

    function activityService($resource, API_URL) {
        return $resource(
            API_URL.ACTIVITY,
            {},
            {
                query: {
                    isArray: false
                }
            }
        );
    }
})();
